<template>
<div class="">
    <header class="card-header grey-header d-flex mob-flex-column ai-center mb-20px">
        <div class="row flex-flow-column">
           <div class="col"><strong>{{$t('tc.exchange')}} </strong></div><!----><p
            v-if="ADMIN_SIGNIN_RES" class="desc">{{$t('exchange.sysExchangeDesc')}}</p>
            <p
            v-if="AGENT_SIGNIN_RES" class="desc">{{$t('exchange.agtExchangeDesc')}}</p></div>

    </header>
    <div class="max-w-800px m-auto ex-card-wrap">

    <div class="card box-shadow-card border-none p-0">

    <div class="card-body"  v-if="GET_TKT_EXCHANGE_OBJ">
       <h4 class="m-auto" v-if="GET_TKT_EXCHANGE_OBJ && GET_TKT_EXCHANGE_OBJ.orderId">
         {{ $t('systemTicketNow.reservationId')}} : {{GET_TKT_EXCHANGE_OBJ.orderId}}</h4>
       <h4 class="m-auto" v-else-if="GET_TKT_EXCHANGE_OBJ && GET_TKT_EXCHANGE_OBJ.bookingDetails && GET_TKT_EXCHANGE_OBJ.bookingDetails.orderID">
         {{ $t('systemTicketNow.reservationId')}} : {{GET_TKT_EXCHANGE_OBJ.bookingDetails.orderID}}</h4>

    </div>
    </div>
    </div>
  <div class="max-w-800px m-auto ex-card-wrap">
  
    <div class=" w-100">
        <cEditFlight
        v-if="lsFlights && lsFlights.length"
        :isExchange='true' 
        :lsFlights="lsFlights"
        @input="onFlightSelection"
        :showPax="true"
        :journeyType="orderDetails.journeyType"
      ></cEditFlight>


    </div>

<CCard>
    <CCardFooter  v-if="!isLoading">

        <CAlert v-if="alertValue" show color="danger">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                <span>{{$t("cAlert.errorCode")+' : '}}</span>
                <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String">
                <p>{{alertValue}}</p>
            </div>
        </CAlert>
        <div class="d-flex justify-content-lg-between">
            <CRow   v-if="orderDetails&&!ADMIN_SIGNIN_RES" @click="toggleExchange">
                <div class="align-center max-w-620px w-100 pl-10px c-pointer">
                    <input type="checkbox" :checked="isExchange" class="m-auto ml-10px mr-10px" />
                    <span>{{ $t("exchange.agree") }}</span>
                    <a class="active-link" @click.stop="isFRModalShow=true">{{ ' '+$t("exchange.tc")+' ' }}</a>
                    <span>{{ $t("exchange.proceed") }}</span>
                </div>
            </CRow>
            <CRow class="d-flex justify-content-end">
                <CButton @click="goBack()"
                         class="btn align-right btn-lit-blue btn-success m-10px bg-danger width-125px"
                >{{ $t("exchange.goBack") }}</CButton>
                
                
                <CButton 
                v-if="orderDetails "
                v-c-tooltip.hover="!canExchange?
                { content:$t('exchange.btnTooltip'),active:false }:''"
                         @click="canExchange?validateOrderDet():null"
                         class="btn align-right btn-lit-blue btn-success m-10px  width-125px"
                >{{ $t("exchange.exchange") }}</CButton>
            </CRow>
        </div>
        <div class="farerule-wrapper">
            <CModal
                    :show.sync="isFRModalShow"
                    :backdrop="true"
                    :closeOnBackdrop="true"
                    :centered="true"
                    size="lg"
                    color="dark"
            >
                <h4 class="font-bold" v-html="$t('tc.title',{title:$t('tc.exchange')})"></h4>
                <br />
                <span v-html="$t('tc.titleContent')"></span>
                <br />
                <h4 v-html="$t('tc.tc')"></h4>
                <br />
                <span v-html="$t('tc.tcContent')"></span>
                <br />
                <span v-html="$t('tc.pointsToNote')"></span>
                <br />
                <br />
                <span v-html="$t('tc.pnContent')"></span>
                <template #footer-wrapper>
        <CCardBody class="d-flex justify-content-end">
          <CRow class="confirm-btn-wrapper">
            
              <CButton
                @click="isFRModalShow=false"
                :color="'success'"
                aria-pressed="true"
              >OK</CButton>
            
          </CRow>
        </CCardBody>
      </template>
                <!-- <span style="text-align: center">{{$t('tc.text')}}</span> -->
            </CModal>
        </div>

    </CCardFooter>
</CCard>

    </div>

    <cAlertModal
      v-if="isConfirmModal"
      :show="isConfirmModal"
      :buttonList="[
        { name: $t('exchange.no'), func: toggleConfirmModal },
        { name: $t('exchange.yes'), func: onConfirmExchange },
      ]"
      :key="1 + 'a'"
      :desc="$t('exchange.confirm')"
      :status="2"
    ></cAlertModal>

    <cAlertModal
      v-if="isSuccessModal"
      :show="isSuccessModal"
      :key="1 + 'b'"
      :desc="$t('exchange.succDesc')"
      :buttonList="[{ name: $t('exchange.ok'), func: navToBookingDet }]"
      :status="1"
    ></cAlertModal>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { COMPONENT_NAME, PATHNAME, DATE_TIME_FORMAT } from "../../../../util/constants";
import {
  addClassToBody,
  removeClassBody,
  cloneDeep,OrderByList
} from "../../../../util/util";
import { formatDate } from "../../../../util/date/dateFunctions";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";

import apiDetForExchange from "./../../../../services/apiDetForExchange";
import apiExchangeInitiate from "./../../../../services/apiExchangeInitiate";
import BaseConfiguration from "../../../../config/base";

import {
  handleJWT,
  getErrorAlertValue,
  handleSessionExist
} from "../../../../util/util";
import {
  ROUTER_PARAM,
  PAYMENT_PROCEED_TO,
  PROCEED_TO_TYPE
} from "../../../../util/constants";
import router, { navigate, goBack, updateDataEdited } from "../../../../router/index";
import cEditFlight from "./../../../../components/booking/flight/manage/cEditFlight";
import cEditPassn from "./../../../../components/booking/flight/manage/cEditPassn";
import cAlertModal from "./../../../../components/form/cAlertModal";

export default {

name:COMPONENT_NAME.EXCHANGE,


 components: {
    cEditFlight,
    cEditPassn,
    cAlertModal
  },
  
  data:()=>{

      return{
      isExchange:false,
      isSuccessModal:false,
      isConfirmModal:false,
      isFRModalShow: false,
      lsPassengers: [],
      alertValue:null,
      orderDetails: null,
      lsFlights: [],
      canExchange: true,
      isLoading:true
      }
  },
   computed: {
    ...mapGetters("cBookingDetail", {GET_TKT_EXCHANGE_OBJ:"GET_TKT_EXCHANGE_OBJ"}),
    ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sAgtLogin", {
                AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
            }),
  },
  methods:{


 goBack() {
      goBack();
    },
    onFlightSelection(pFlights) {
      try {
        if (BaseConfiguration.isDebug) console.log("onFlightSelection");

        this.lsFlights=pFlights;

     
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.REFUND,
          "error in onFlightSelection",
          err.toString(),
          "onFlightSelection",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    validateOrderDet() {
      try {
        if (BaseConfiguration.isDebug) console.log("validateOrderDet");

        if (this.lsFlights && this.lsFlights.length) {
          let flightObj = this.lsFlights.find(flight => flight.isSelected);

           let exchangedFlightObj=[]
        //    else{
        //   this.alertValue = null;
        // }

          if(!flightObj )
          {
            this.alertValue =this.$t('exchange.alert')
          } else if (flightObj){
            let selFlights=[]
            this.lsFlights.forEach(flight => {
            if (flight && flight.isSelected) {
            
              if(flight.exchangeDate==null){
                    this.alertValue = 'Please select exchange date'
                    } else{
                      this.alertValue=null
                    }
            }
            });

          }
          if(this.alertValue==null && !this.isExchange&&this.AGENT_SIGNIN_RES)
          {
            this.alertValue =this.$t('exchange.alertTc')
          }
          
          if(this.alertValue==null)
          {
            this.alertValue=null;
            this.toggleConfirmModal()
          }


        }
      } catch (err) {
        let body = Logger.buildRequest(
        FILE_NAME.EXCHANGE,
          "error in validateOrderDet",
          err.toString(),
          "validateOrderDet",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSelectedFlightIds() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedFlightIds");

        if (this.lsFlights && this.lsFlights.length)
          this.lsFlights.forEach(flight => {
            if (flight && flight.isSelected)
              retValue.push({
                flightId: flight.orderItemId,
                	exchangeDate:formatDate(flight.exchangeDate,DATE_TIME_FORMAT.API_DATE_FORMAT),
		              	remarks:flight.remarks,

                paxIds: flight.passengerInfo
                  .map(pax => {
                    if (pax.isSelected) 
                    {
                    return pax.paxId;
                    }
                  })
                  .filter(val => val != null)
              });
          });

         
          
      } catch (err) {
        let body = Logger.buildRequest(
        FILE_NAME.EXCHANGE,
          "error in getSelectedFlightIds",
          err.toString(),
          "getSelectedFlightIds",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createExchange() {
      try {
        if (BaseConfiguration.isDebug) console.log("createExchange");

        let lsFlightIds = this.getSelectedFlightIds();
        let orderid = null;
        if(this.GET_TKT_EXCHANGE_OBJ && this.GET_TKT_EXCHANGE_OBJ.bookingDetails)  {
          if(this.GET_TKT_EXCHANGE_OBJ.bookingDetails.exchangeOrderId) {
            orderid = this.GET_TKT_EXCHANGE_OBJ.bookingDetails.exchangeOrderId;
          } else if(this.GET_TKT_EXCHANGE_OBJ.bookingDetails.orderID){
            orderid = this.GET_TKT_EXCHANGE_OBJ.bookingDetails.orderID;
          }
        }else if(this.GET_TKT_EXCHANGE_OBJ && this.GET_TKT_EXCHANGE_OBJ.exchangeOrderId) {
          orderid = this.GET_TKT_EXCHANGE_OBJ.exchangeOrderId;
        }else if(this.GET_TKT_EXCHANGE_OBJ && this.GET_TKT_EXCHANGE_OBJ.orderId) {
          orderid = this.GET_TKT_EXCHANGE_OBJ.orderId;
        }

        if ( 
           orderid &&
          lsFlightIds &&
          lsFlightIds.length
        ) {
          let createExchangeReq = apiExchangeInitiate.buildRequest(
            orderid,
            lsFlightIds
          );

          if (createExchangeReq != null) {
            let createExchangeRes = await apiExchangeInitiate.getResponse(
              createExchangeReq
            );

            if (VALIDATE_SUCCESS_RES(createExchangeRes)) {
              this.toggleSuccessModal();
            } else {
              let error = getErrorMessage(createExchangeRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          } else {
            throw "invallid Req";
          }
        } else {
          throw " inavild order details";
        }
         updateDataEdited(false);
      } catch (err) {
        let body = Logger.buildRequest(
        FILE_NAME.EXCHANGE,
          "error in createExchange",
          err.toString(),
          "createExchange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },



















      navToBookingDet() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToBookingDet");

        this.toggleSuccessModal();
        navigate(PATHNAME.MY_BOOKING);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in navToBookingDet",
          err.toString(),
          "navToBookingDet",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleExchange() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleExchange");
        this.isExchange = !this.isExchange;
        updateDataEdited(true);
        if(this.alertValue)
          {
            this.alertValue=null;
          }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in toggleExchange",
          err.toString(),
          "toggleExchange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onConfirmExchange() {
      try {
        if (BaseConfiguration.isDebug) console.log("onConfirmExchange");
        this.toggleConfirmModal();


        this.createExchange()
      //  this.toggleSuccessModal();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in onConfirmExchange",
          err.toString(),
          "onConfirmExchange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    toggleSuccessModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleSuccessModal");
        this.isSuccessModal = !this.isSuccessModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in toggleSuccessModal",
          err.toString(),
          "toggleSuccessModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleConfirmModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleConfirmModal");

        this.isConfirmModal = !this.isConfirmModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in toggleConfirmModal",
          err.toString(),
          "toggleConfirmModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },







       async getBookingDetails(pOrderId) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getBookingDetails");

        if (pOrderId) {
          let bookingDetReq = apiDetForExchange.buildRequest(pOrderId);

          if (bookingDetReq != null) {
            let bookingDetRes = await apiDetForExchange.getResponse(
              bookingDetReq
            );

            if (VALIDATE_SUCCESS_RES(bookingDetRes)) {
              retValue = bookingDetRes.data.data;
            } else {
              let error = getErrorMessage(bookingDetRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          } else {
            throw "invallid Req";
          }
        } else {
          throw " invalid Order Id";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in getBookingDetails",
          err.toString(),
          "getBookingDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },





 getPassengersList(pOrderDet, PFlightObj) {
      let retValue = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getPassengersList");

        if (pOrderDet && pOrderDet.passengerInfo) {
          let lsPassn = Object.values(pOrderDet.passengerInfo);
          let paxList = [];
          if (lsPassn && lsPassn.length && PFlightObj) {
            lsPassn.forEach(pax => {
              let ticketNumber = "";

              if (PFlightObj.passengerInfo && PFlightObj.passengerInfo.length) {
                let paxInfo = PFlightObj.passengerInfo.find(info => {
                  return info.paxId == pax.paxId;
                });

                if (paxInfo)
                  Object.keys(pax).forEach(key => {
                    paxInfo[key] = pax[key];
                  });
                   paxList.push(paxInfo);
              }
            });
             let orderPaxList = [];
            let frstKey = Object.keys(paxList)[0];
        if(paxList[frstKey].isLeadPax!=true) {
        for(var i in paxList) {
          orderPaxList.push(paxList[i]);
        }
        
        paxList = orderPaxList.reverse()
        }else{
          for(var i in paxList) {
          orderPaxList.push(paxList[i]);
        }
          paxList = orderPaxList
        }
             PFlightObj.passengerInfo = paxList; 
          }
          retValue = cloneDeep(PFlightObj.passengerInfo);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in getPassengersList",
          err.toString(),
          "getPassengersList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    getTravelDuration(pFlights) {
      let retValue = 0;
      try {
        if (BaseConfiguration.isDebug) console.log("getTravelDuration");

        if (pFlights && pFlights.length)
          pFlights.forEach(flights => {
            retValue += flights.flight.DurationInMin;
          });
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in getTravelDuration",
          err.toString(),
          "getTravelDuration",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getFlightsList(pOrderDet) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getFlightsList");

        if (pOrderDet && pOrderDet.flights && pOrderDet.flights.length) {
          let ordLs=[];
           pOrderDet.flights.filter(aobj => {
                if(aobj.canExchange){
                    ordLs.push(aobj);
                    }
                    });
          if(ordLs.length!=0){
            this.canExchange=true
               }else{
                      this.canExchange=false
                    }
          pOrderDet.flights.forEach(flight => {
            flight.passengerInfo = this.getPassengersList(pOrderDet, flight);

            if (flight.flightInfo && flight.flightInfo.length) {


              flight.flightInfo = OrderByList(
                flight.flightInfo,
                "connectingNumber",
                "asc"
              );

              flight.travelDuration=this.getTravelDuration(flight.flightInfo);
              flight.exchangeDate=flight.exchangeDate
              flight.showFlightDet = false;
              flight.orderType = pOrderDet.orderType;
                            flight.status = pOrderDet.status;

              flight.flightInfo.forEach(fInfo => {
                if (fInfo.flight) {
                  if (pOrderDet.airline) {
                    let airlineObj = Object.values(pOrderDet.airline).find(
                      airline => airline.airline_code == fInfo.flight.opAirline
                    );

                    if (airlineObj) {
                      fInfo.flight.airline_name = airlineObj.airline_name;
                      fInfo.flight.logo_url = airlineObj.logourl;
                    }
                  }
                  if (pOrderDet.airport) {
                    fInfo.flight.arrCity =
                      pOrderDet.airport[fInfo.flight.ArrAirport].city;
                    fInfo.flight.depCity =
                      pOrderDet.airport[fInfo.flight.DepAirport].city;
                  }
                }
              });
            }
          });

          retValue = cloneDeep(pOrderDet.flights);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.EXCHANGE,
          "error in getFlightsList",
          err.toString(),
          "getFlightsList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }




















  },


   async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      if(this.GET_TKT_EXCHANGE_OBJ && this.GET_TKT_EXCHANGE_OBJ.bookingDetails) {
          this.orderDetails = await this.getBookingDetails( this.GET_TKT_EXCHANGE_OBJ.bookingDetails.exchangeOrderId ?
                              this.GET_TKT_EXCHANGE_OBJ.bookingDetails.exchangeOrderId : this.GET_TKT_EXCHANGE_OBJ.bookingDetails.orderID ?
                              this.GET_TKT_EXCHANGE_OBJ.bookingDetails.orderID:null);
      }
      else if (this.GET_TKT_EXCHANGE_OBJ && this.GET_TKT_EXCHANGE_OBJ.orderId) {
        this.orderDetails = await this.getBookingDetails(
          this.GET_TKT_EXCHANGE_OBJ.orderId
        );
        
      }
         
      // if (this.GET_TKT_EXCHANGE_OBJ && this.GET_TKT_EXCHANGE_OBJ.bookingDetails && this.GET_TKT_EXCHANGE_OBJ.bookingDetails.exchangeOrderId) {
      //   this.orderDetails = await this.getBookingDetails(
      //     this.GET_TKT_EXCHANGE_OBJ.bookingDetails.exchangeOrderId
      //   );
          // console.error(this.GET_TKT_EXCHANGE_OBJ) 
      

        //  this.lsPassengers = this.getPassengersList(this.orderDetails)
        if(this.orderDetails) {
       this.lsFlights = this.getFlightsList(this.orderDetails);
        }
      this.isLoading=false;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.EXCHANGE,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
    beforeCreate() {    
   addClassToBody(COMPONENT_NAME.EXCHANGE);
  },
  
   beforeDestroy() {
      
       removeClassBody();
    },
}
</script>

<style lang="scss" scoped>
.active-link {
    color: #2f85eb !important;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      text-decoration: underline !important;
    }
    
  }
</style>